const SUB_TYPE = "ssml-sub";

export { SUB_TYPE };
//# sourceMappingURL=constant.js.map
